module.exports = __webpack_public_path__ + "img/index01.1ef2d0ce.jpg";